export const currentLang = ({ language }) => language.language;
